import { gql } from 'apollo-boost'

const uploadFile = gql`
  mutation uploadFile($file: Upload!, $name: String!) {
    uploadFile(file: $file, name: $name) {
      name
    }
  }
`

export default uploadFile


// WEBPACK FOOTER //
// ./src/graphql/mutations/uploadFile.js